/// <reference path="../../app.definition.ts" />

import { Serializable } from "./Serializable";
import { User } from "./user";

export class DiscussionComment implements Serializable<DiscussionComment> {


    // timestamp: number;
    // sender: User;
    // comment: String;
    // senderId: number;


    id: number;
    topic: any;
    comment: any;
    commentTime: any;
    senderId: number;
    senderDesignation: String;
    documentId: number;
    objectId: number;
    objectType: String;
    password: String;
    methodName: String;
    senderPhoto;
    senderPhotoMimeType;
    sender;
    commentType: string;
    senderBgColor: string;
    meta: string;
    metaValue: string;
    userId: number;
    isEdited: boolean;
    editedTime: any;
    deleted: boolean;

    deserialize(input) {

        input.id && (this.id = input.id);
        input.topic && (this.topic = input.topic);

        input.senderPhoto && (this.senderPhoto = input.senderPhoto);
        input.commentType && (this.commentType = input.commentType);
        input.comment && (this.comment = input.comment);
        input.commentTime && (this.commentTime = new Date(input.commentTime).getTime());
        input.senderId && (this.senderId = input.senderId);
        input.documentId && (this.documentId = input.documentId);
        input.objectId && (this.objectId = input.objectId);
        input.objectType && (this.objectType = input.objectType);
        input.password && (this.password = input.password);
        input.methodName && (this.methodName = input.methodName);
        input.senderDesignation && (this.senderDesignation = input.senderDesignation);
        input.senderBgColor && (this.senderBgColor = input.senderBgColor);
        input.sender && (this.sender = input.sender);
        input.senderFirstName && (this.sender = new User().deserialize(
            { firstName: input.senderFirstName, lastName: input.senderLastName, userId: input.senderId, photo: input.senderPhoto, bgColor: input.senderBgColor }
        ));
        input.meta && (this.meta = input.meta);
        input.metaValue && (this.metaValue = input.metaValue);
        input.userId && (this.userId = input.userId);
        input.isEdited && (this.isEdited = input.isEdited);
        input.editedTime && (this.editedTime = new Date(input.editedTime).getTime());
        input.deleted && (this.deleted = input.deleted);
        return this;
    }

    constructor() {
    }


}
